import { render, staticRenderFns } from "./coures.vue?vue&type=template&id=6e99fbf0&scoped=true&"
import script from "./coures.vue?vue&type=script&lang=js&"
export * from "./coures.vue?vue&type=script&lang=js&"
import style0 from "./coures.vue?vue&type=style&index=0&id=6e99fbf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e99fbf0",
  null
  
)

export default component.exports